<div class="requests-header-container">
  <div class="header-title">
    <a class="back-to-dashboard-link" role="button" routerLink="/dboard" (keydown)="navigateToDashboard()">
      <mat-icon class="back-icon">arrow_back</mat-icon>Back to Dashboard
    </a>
    <h3>Request Tickets {{ prfyear }}</h3>
  </div>
  <div class="header-right">
    <button
      class="reload-btn"
      ngbTooltip="Reload List"
      placement="top"
      tooltipClass="tooltip-class"
      (click)="loadRequests()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <app-button size="medium" buttonType="primary" (click)="openNewRequestModal()" (keydown)="openNewRequestModal()">New Request</app-button>
  </div>
</div>

<div class="requests-table-container">
  <div class="loading-screen" *ngIf="isLoading; else table">
    <div class="skeleton-table">
      <div class="skeleton-header">
        <div class="skeleton-cell" *ngFor="let header of skeletonHeaders"></div>
      </div>
      <div class="skeleton-row" *ngFor="let row of skeletonRows">
        <div class="skeleton-cell" *ngFor="let cell of skeletonHeaders"></div>
      </div>
    </div>
  </div>
  <ng-template #table>
    <table class="table table-hover" *ngIf="data?.length > 0; else noData">
      <thead>
        <tr>
          <th></th>
          <th>PRF Number</th>
          <th>Request Type</th>
          <th>Created Date</th>
          <th>Last Updated</th>
          <th>Status</th>
          <th>Action</th>
          <th>View Details</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let element of data; let i = index">
          <!-- Regular row -->
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ element.prfnumber }}</td>
            <td>{{ element.requesttype || 'N/A' }}</td>
            <td class="grey-fs">{{ formatDate(element.createdat) }}</td>
            <td class="grey-fs">{{ formatDate(element.updatedat) }}</td>
            <td>
              <div class="status-container">
                <span [ngClass]="{
                    'status-label-pending': element.status === 'Open',
                    'status-label-approved': element.status === 'Completed',
                    'status-label-rejected': element.status === 'Declined',
                    'status-label-cancelled': element.status === 'Cancelled',
                    'status-label-processing': element.status === 'Processing'
                  }">
                  {{ element.status }}
                </span>
              </div>
            </td>
            <td>
              <app-button 
                size="small"
                buttonType="secondary"
                (click)="openCancelRequestModal(element.ticketid)"
                (keydown)="openCancelRequestModal(element.ticketid)"
                [disabled]="element.status !== 'Open'">
                Delete
              </app-button>
            </td>
            <td>
              <span 
                (click)="toggleDetails(i)"
                (keydown)="toggleDetails(i)"
                class="view-details-btn">
                <mat-icon>{{ expandedRowIndex === i ? 'expand_less' : 'expand_more' }}</mat-icon>
                <span class="view-details-text">View Details</span>
              </span>
            </td>
          </tr>
          
          <!-- Details row -->
          <tr *ngIf="expandedRowIndex === i">
            <td colspan="8" class="details-slide">
              <div class="details-content">
                <strong>PRF Number:</strong> {{ element.prfnumber }}<br/>
                <strong>Request Type:</strong> {{ element.requesttype }}<br/>
                <strong>User Comment:</strong> {{ element.customercomment || 'N/A' }}<br/>
                <strong>Created Date:</strong> {{ formatDate(element.createdat) }}<br/><br/>
                <strong>Status:</strong> {{ element.status }}<br/>
                <strong>Remarks:</strong> {{ element.admincomment || 'N/A' }}<br/>          
                <strong>Last Updated:</strong> {{ formatDate(element.updatedat) }}<br/>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-template>
  <ng-template #noData>
    <div class="no-data">
      <mat-icon class="no-data-icon">assignment_late</mat-icon>
      <p class="no-data-text">No Requests Found</p>
    </div>
  </ng-template>
</div>